import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import SustainabilityPage from './pages/SustainabilityPage';
import ChatGPTPage from './pages/ChatGPTPage';
import MarketingPage from './pages/MarketingPage';
import CryptoPage from './pages/CryptoPage';
import ForexPage from './pages/ForexPage';
import CommoditiesPage from './pages/CommoditiesPage';
import IndicesPage from './pages/IndicesPage';
import BondsPage from './pages/BondsPage';
import FundsPage from './pages/FundsPage';
import ETFPage from './pages/ETFPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import CookiePolicyPage from './pages/CookiePolicyPage';
import GDPRPage from './pages/GDPRPage';
import AMLCTFPage from './pages/AMLCTFPage';
import PartnersPage from './pages/PartnersPage';
import BigDataAnalyticsPage from './pages/BigDataAnalyticsPage';
import AIConsultingPage from './pages/AIConsultingPage';
import ContactPage from './pages/ContactPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import RulesPage from './pages/RulesPage';
import DashboardPage from './pages/DashboardPage';
import AdminPanel from './pages/AdminPanel';
import SettingsPage from './pages/SettingsPage';
import FruitCrushPage from './pages/FruitCrushPage';
import NewsManagementPage from './pages/NewsManagementPage';
import CreationsManagementPage from './pages/CreationsManagementPage';
import LatestNewsPage from './pages/LatestNewsPage';
import EducationPage from './pages/EducationPage';
import AuthCallback from './pages/AuthCallback';
import { Toaster } from './components/ui/toaster';
import './App.css';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/sustainability" element={<SustainabilityPage />} />
            <Route path="/chatgpt" element={<ChatGPTPage />} />
            <Route path="/marketing" element={<MarketingPage />} />
            <Route path="/crypto" element={<CryptoPage />} />
            <Route path="/forex" element={<ForexPage />} />
            <Route path="/commodities" element={<CommoditiesPage />} />
            <Route path="/indices" element={<IndicesPage />} />
            <Route path="/bonds" element={<BondsPage />} />
            <Route path="/funds" element={<FundsPage />} />
            <Route path="/etf" element={<ETFPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-of-service" element={<TermsOfServicePage />} />
            <Route path="/cookie-policy" element={<CookiePolicyPage />} />
            <Route path="/gdpr" element={<GDPRPage />} />
            <Route path="/aml-ctf" element={<AMLCTFPage />} />
            <Route path="/partners" element={<PartnersPage />} />
            <Route path="/marketing" element={<MarketingPage />} />
            <Route path="/big-data-analytics" element={<BigDataAnalyticsPage />} />
            <Route path="/sustainability" element={<SustainabilityPage />} />
            <Route path="/ai-consulting" element={<AIConsultingPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/rules" element={<RulesPage />} />
            <Route path="/games/fruitcrush" element={<FruitCrushPage />} />
            <Route path="/news" element={<LatestNewsPage />} />
            <Route path="/education" element={<EducationPage />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/admin-fxcvantage/adminpanel" element={<ProtectedRoute><AdminPanel /></ProtectedRoute>} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminPanel />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <SettingsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/news"
              element={
                <ProtectedRoute>
                  <NewsManagementPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/creations"
              element={
                <ProtectedRoute>
                  <CreationsManagementPage />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
